import DownloadService from "@/utils/download-service";

export const previewFormDefinition = async (formDefinitionID: string, onComplete: () => void) => {
    await DownloadService.downloadFile('POST', '/FormDefinition/Preview', {
        formDefinitionID
    }, true, undefined, "", "", null, false, onComplete as any);
};
